import type { ReduxState } from '@/redux'

export const proveAvailableLineItems = (state: ReduxState) => state.proveLineItem.available;
export const proveLineItemIsPending = (state: ReduxState) => state.proveLineItem.isPending;
export const proveLineItemIsError = (state: ReduxState) => state.proveLineItem.isError;
